import { useSiteSettings } from '@/hooks/useSiteSettings';

export default function WhatsAppFloat() {
  const { data: settings } = useSiteSettings();
  // extract the digits only, strip any leading +, spaces or dashes so wa.me links work reliably
  const raw = (settings?.whatsapp_number ?? '').replace(/[^\d]/g, '');
  const number = raw.replace(/^0+/, '');
  const enabled = settings?.whatsapp_enabled ?? true;

  if (!enabled || !number) return null;

  return (
    <a
      href={`https://wa.me/${number}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 group"
    >
      <span className="hidden sm:inline-block px-3 py-1.5 rounded-full bg-white shadow-sm border border-background-200 text-xs font-label font-medium text-foreground-700 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 whitespace-nowrap">
        Chat with us
      </span>
      <span className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-500 hover:bg-secondary-600 transition-colors shadow-sm cursor-pointer">
        <i className="ri-whatsapp-line text-white text-3xl" aria-hidden="true" />
      </span>
    </a>
  );
}